import { createSlice } from "@reduxjs/toolkit";
import { getCasesTypeByTenantId } from "./thunks";

const initialState = {
  caseTypesByTenants: {},
  loading: true,
};

const casesSlice = createSlice({
  name: "cases",
  initialState,
  reducers: {
    setKeyValue: (state, action) => {
      const { key, value } = action.payload;
      state[key] = value;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getCasesTypeByTenantId.pending, (state) => {
        state.loading = true;
      })
      .addCase(getCasesTypeByTenantId.fulfilled, (state, action) => {
        const { tenant_id } = action.meta.arg;
        const { data } = action.payload;

        state.caseTypesByTenants[tenant_id] = data;
        state.loading = false;
      })
      .addCase(getCasesTypeByTenantId.rejected, (state) => {
        state.loading = false;
      });
  },
});

export const { setKeyValue } = casesSlice.actions;

export default casesSlice.reducer;
